import Alert from "@pathwright/ui/src/components/alert/Alert"
import {
  FeatureAction,
  FeatureContextInput,
  FeatureKey,
  useContextualFeaturePermissionQuery
} from "../../api/generated"
import { featurePermissionsQueryPropTypes } from "../propTypes"
import FeatureBlock from "./FeatureBlock"

const FeatureBlockContainer = ({
  featureKey,
  featureAction,
  context,
  to
}: {
  featureKey: FeatureKey
  featureAction: FeatureAction
  context: FeatureContextInput | null
  to?: string | object | null
}) => {
  const cfpQuery = useContextualFeaturePermissionQuery({
    variables: {
      featureKey,
      featureAction,
      context
    }
  })

  if (cfpQuery.loading) return null
  if (cfpQuery.error) return <Alert error={cfpQuery.error} />

  const feature = cfpQuery.data?.contextualFeaturePermission

  return feature ? (
    <FeatureBlock
      featureKey={feature.feature_key}
      featurePermission={feature.permission_in_context}
      to={to}
    />
  ) : null
}

FeatureBlockContainer.displayName = "FeatureBlockContainer"

FeatureBlockContainer.propTypes = featurePermissionsQueryPropTypes

export default FeatureBlockContainer
